import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "./ui/alert-dialog";

// Proteção contra perda de preenchimento (item 13 do pedido) — componente
// ÚNICO reutilizado por Ficha de Visita (Nova/Editar) e Novo Cliente, em
// vez de duas implementações diferentes da mesma confirmação.
export default function ConfirmCloseDialog({
  open, onOpenChange, onConfirm,
  title = "Descartar alterações?",
  description = "Há alterações não salvas. Se você sair agora, o preenchimento será perdido.",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-close-continuar">Continuar editando</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700" data-testid="confirm-close-descartar">
            Descartar e sair
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
